import { i18n } from '../../i18n'

// Session-cookie GraphQL fetch, following the CompletedHikes precedent: the
// Rails session authenticates the request, so signed-in state needs no
// Firebase round-trip and anonymous visitors get public data.
export async function postGraphql<T> (query: string, variables: Record<string, unknown> = {}): Promise<T> {
  const csrfToken =
    (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null)?.content || ''

  const response = await fetch('/graphql', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken
    },
    body: JSON.stringify({ query, variables })
  })

  const payload = await response.json()
  if (payload.errors?.length) {
    throw new Error(payload.errors[0].message || i18n.global.t('peak_bagging.api.something_went_wrong'))
  }
  return payload.data as T
}
